import React, { useEffect, useState, useRef } from "react";
import { db } from "./firebase";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import "./App.css";

function App() {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [streams, setStreams] = useState<
    {
      name: string;
      url: string;
      cover?: string;
    }[]
  >([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [nameInput, setNameInput] = useState("");
  const [urlInput, setUrlInput] = useState("");
  const [coverInput, setCoverInput] = useState("");

  useEffect(() => {
    const loadStreams = async () => {
      const docRef = doc(db, "streams", "main");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setStreams(docSnap.data().list || []);
      } else {
        // Erstelle leeres Dokument, falls nicht vorhanden
        await setDoc(docRef, { list: [] });
        setStreams([]);
      }
    };
    loadStreams();
  }, []);

  const addStream = async () => {
    if (!nameInput || !urlInput) return;

    const newStreams = [
      ...streams,
      { name: nameInput, url: urlInput, cover: coverInput },
    ];

    const docRef = doc(db, "streams", "main");
    await updateDoc(docRef, { list: newStreams });

    setStreams(newStreams);
    setCurrentIndex(newStreams.length - 1);

    setNameInput("");
    setUrlInput("");
    setCoverInput("");
    setShowModal(false);
  };

  const loadTrack = async (index: number) => {
    const track = streams[index];
    const audio = audioRef.current;

    if (!audio) return;

    setCurrentIndex(index);

    audio.src = track.url;
    try {
      await audio.play();
    } catch (error) {
      console.error("Fehler beim Abspielen des Audios:", error);
    }

    navigator.mediaSession.metadata = new MediaMetadata({
      title: track.name,
      //artist: "track.artist111",
      // album: "Album",
      artwork: [
        {
          src: "/webradio/cover/" + track.cover || "",
          sizes: "512x512",
          type: "image/jpeg",
        },
      ],
    });

    navigator.mediaSession.setActionHandler("previoustrack", () => {
      const newIndex = index < streams.length - 1 ? index + 1 : 0;
      loadTrack(newIndex);
    });
    navigator.mediaSession.setActionHandler("nexttrack", () => {
      const newIndex = index > 0 ? index - 1 : streams.length - 1;
      loadTrack(newIndex);
    });
  };

  const stop = async () => {
    try {
      audioRef.current?.pause();
    } catch (error) {
      console.error("Fehler beim Pausieren des Audios:", error);
    }
  };

  return (
    <div className="app">
      <header>
        <h1>🎧 Webradio</h1>
        <button className="add-btn" onClick={() => setShowModal(true)}>
          +
        </button>
      </header>

      <div className="dashboard">
        {streams.map((stream, index) => (
          <div
            key={index}
            className="card"
            onClick={() => {
              loadTrack(index);
            }}
          >
            <strong>{stream.name}</strong>
          </div>
        ))}
      </div>

      {currentIndex !== null && streams[currentIndex] && (
        <div className="player">
          {isPlaying && (
            <>
              <div className="now-playing">{streams[currentIndex].name}</div>
              <button className="stop-button" onClick={stop} />
            </>
          )}
          <audio
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            ref={audioRef}
          />
        </div>
      )}

      {showModal && (
        <div className="modal-backdrop">
          <div className="modal">
            <h2>Stream hinzufügen</h2>

            <input
              type="text"
              placeholder="Name (z.B. Radio Rock)"
              value={nameInput}
              onChange={(e) => setNameInput(e.target.value)}
            />

            <input
              type="text"
              placeholder="Cover"
              value={coverInput}
              onChange={(e) => setCoverInput(e.target.value)}
            />

            <input
              type="text"
              placeholder="Stream URL"
              value={urlInput}
              onChange={(e) => setUrlInput(e.target.value)}
            />

            <div className="modal-actions">
              <button onClick={addStream}>Hinzufügen</button>
              <button onClick={() => setShowModal(false)}>Abbrechen</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
